<template>
  <div>
    <span>{{item.firstname}} {{item.lastname}} : {{ item.email }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
  },
};
</script>